import clsx from "clsx"

type GridLayoutProps = {
    children: React.ReactNode
    className?: string
}

const GridLayout = (Props: GridLayoutProps) => {
    return(
        <div className={clsx(Props.className,"px-4 grid-cols-1 xl:px-0 grid md:grid-cols-12 md:gap-x-8 md:gap-y-9 mx-auto max-w-5xl")}>
            {Props.children}
        </div>
    )
}

export default GridLayout